// @flow
import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';
import { del, get, post, put } from '../utils/api';

export default class GrossRentsService {
  getGrossRentChanges(
    organizationId: string,
    propertyId: string,
    options?: Object,
  ): Promise<any> {
    return get(`/${organizationId}/${propertyId}/gross-rent-changes`, options);
  }

  getGrossRentCertifications(
    organizationId: string,
    propertyId: string,
    options?: Object,
  ): Promise<any> {
    return get(
      `/${organizationId}/${propertyId}/manage-gross-rent-certifications`,
      options,
    );
  }

  getAnticipatedVoucherMonth(
    organizationId: string,
    propertyId: string,
    effectiveDate: string,
    options?: Object,
  ): Promise<{| anticipatedVoucherMonth?: string |}> {
    return get(
      `/${organizationId}/${propertyId}/anticipated-voucher-month?effectiveDate=${encodeURIComponent(
        effectiveDate,
      )}`,
      options,
    );
  }

  getGrossRentCertExistsForYear(
    organizationId: string,
    propertyId: string,
    year: number,
    options?: Object,
  ): Promise<{| exists?: boolean |}> {
    return get(
      `/${organizationId}/${propertyId}/gross-rent-cert-exists-for-year?year=${year}`,
      options,
    );
  }

  updateGrossRentChange(
    organizationId: string,
    propertyId: string,
    payload: Object,
    options?: Object,
  ): Promise<Object> {
    return put(
      `/${organizationId}/${propertyId}/gross-rent-changes`,
      JSON.stringify(payload),
      options,
    );
  }

  deleteGrossRentChange(
    organizationId: string,
    propertyId: string,
    effectiveDate: string,
    options?: Object,
  ): Promise<Object> {
    return del(
      `/${organizationId}/${propertyId}/gross-rent-changes`,
      JSON.stringify({ effectiveDate: formatDateDB(effectiveDate) }),
      options,
    );
  }

  cancelGrossRentCertification(
    organizationId: string,
    propertyId: string,
    affordableQualificationId: string,
    options?: Object,
  ): Promise<Object> {
    return del(
      // eslint-disable-next-line max-len
      `/${organizationId}/${propertyId}/affordable-qualifications/${affordableQualificationId}/cancel-gross-rent-certification`,
      undefined,
      options,
    );
  }

  editGrossRentCertification(
    organizationId: string,
    propertyId: string,
    affordableQualificationId: string,
    payload: Object,
    options?: Object,
  ): Promise<Object> {
    return put(
      `/${organizationId}/${propertyId}/affordable-qualifications/${affordableQualificationId}/edit-gross-rent`,
      JSON.stringify(payload),
      options,
    );
  }

  batchCompleteGrossRentCertifications(
    organizationId: string,
    propertyId: string,
    affordableQualificationIds: string[],
    options?: Object,
  ): Promise<Object> {
    return post(
      `/${organizationId}/${propertyId}/batch-complete-gross-rent-certifications`,
      JSON.stringify({ affordableQualificationIds }),
      options,
    );
  }
}
